<template>
  <div class="news">
    <div class="banner">
      <div class="banner-img">
        <img src="../assets/img/top2.png" />
      </div>
      <div class="banner-title">
        <p>{{this.$root.language == 1?title:title_en}}</p>
      </div>
    </div>
    <div class="news-section">
      <div class="row">
        <div class="col-md-1 col-sm-0 col-xs-0 col-lg-2"></div>
        <!-- <div
          class="news-section-content col-md-10 col-sm-12 col-xs-12 col-lg-8"
        >
          <div class="content-nav">
            <div
              class="content-nav-btn"
              :class="{ 'content-nav-active': newstype == 1 }"
              @click="newstype = 1"
            >
              <span>普碳</span>
            </div>
            <div
              class="content-nav-btn"
              :class="{ 'content-nav-active': newstype == 2 }"
              @click="newstype = 2"
            >
              <span>特碳</span>
            </div>
          </div>

          <div class="content-nav-item row">
            <div class="content">
              <div class="text-content" v-show="showContent">
                <p style="padding: 50px 0 20px 0">
                  特炭是相对于传统普通特炭（简称普炭）而言的可以赋予制品特殊性能要求的炭黑，特炭在胶体指标和应用特性方面明显区别于普炭。
                  安仑化工自2020年下半年开始加大特炭的开发力度，在过去一年半时间内目前已开发五大系列十几个品种。
                </p>
              </div>
            </div>
            <div
              class="item-list col-lg-12 col-md-12 col-ms-12 col-xs-12"
              v-for="(product, index) in newsList"
              :key="index"
            >
              <div class="top" style="width: 100%">
                <div class="row" style="width: 100%; margin: 30px">
                  <div
                    style="font-size: 32px; margin-top: 30px"
                    class="col-lg-6 col-md-6 col-ms-6 col-xs-12"
                  >
                    {{ product.Title }}
                  </div>
                  <div class="proImg col-lg-6 col-md-6 col-ms-6 col-xs-12">
                    <img
                      style="width: 50%; height: 100%; margin: 0 auto"
                      :src="product.Img"
                    />
                  </div>
                </div>
                <div class="cst_cardlist_grid_icon">
                  <div class="cst_grid">
                    <div class="row cst_textSetting c-row">
                      <div
                        v-for="(item, index) in product.children"
                        :key="index"
                        class="
                          col-lg-4 col-md-4 col-sm-6 col-xs-6
                          c-column c-inline-column
                        "
                      >
                        <div class="cst_block_item">
                          <h4 style="padding-top: 30px">{{ item.Title }}</h4>
                          <p
                            style="
                              height: 120px;
                              color: #434343;
                              padding: 0 30px 30px;
                            "
                          >
                            {{ item.Content }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="endContent"
              style="
                width: 100%;
                border-bottom: 1px solid;
                background-color: rgb(250, 250, 250);
                margin-top: 10px;
              "
              v-show="showContent"
            >
              <div
                class="childrenTitle"
                style="width: 100%; text-align: center"
              >
                <h3 style="padding: 30px 0">环保系统炭黑</h3>
              </div>
              <div
                style="width: 100%; text-align: center; padding-bottom: 15px"
              >
                <span>敬请期待</span>
              </div>
            </div>
          </div>
        </div> -->
        <div class="tableWrap col-md-10 col-sm-12 col-xs-12 col-lg-8">
          <div
            class="title"
            style="
              border-bottom: 2px solid #ee7a18;
              background-image: url(../assets/img/tabsTitle.jpg);
            "
          >
            <!-- <h1 style="text-align: center; padding: 50px">产品中心</h1> -->
          </div>
          <!-- <el-table :data="dataList" stripe :header-cell-style="{background: '#ee7a18', color: '#ffffff', height: '80px',fontSize: '16px',fontFamily: 'Microsoft YaHei'}" :row-style="{height: '80px'}" class="wow animate__animated animate__fadeInUp">
            <el-table-column prop="Title" label="产品编号" width="250px" align="center"></el-table-column>
            <el-table-column prop="Content" label="产品用途" align="center"></el-table-column>
            <el-table-column label="数据表" width="100px" align="center">
              <template slot-scope="scope">
                <img style="width: 50%;margin: 0 15px;cursor: pointer;" @click="handleClick(scope.row)" src="../assets/img/pro_table_1.png" />
              </template>
            </el-table-column>
            <el-table-column label="联系我们" width="100px" align="center">
              <template slot-scope="scope">
                <img @click="clickPhone(scope.row)" style="width: 50%;margin: 0 15px;cursor: pointer;" src="../assets/img/pro_table_3.png" />
              </template>
            </el-table-column>
          </el-table> -->
          <el-tabs
            class="table-tab"
            v-model="activeName"
            @tab-click="tabClick"
            style="background-color: #ffffff">
            <el-tab-pane :label="this.$root.language == 1?'轮胎用炭黑':'Tyres'" name="first">
              <div><LunTai></LunTai></div >
            </el-tab-pane>
            <el-tab-pane :label="this.$root.language == 1?'工业橡胶制品炭黑':'IndustrialRubber'" name="second">
              <div ><XIANGJIAO></XIANGJIAO></div>
            </el-tab-pane>
            <el-tab-pane :label="this.$root.language == 1?'能源材料用炭黑':'EnergyMaterials'" name="third">
              <div><NENGYUAN></NENGYUAN></div>
            </el-tab-pane>
            <el-tab-pane :label="this.$root.language == 1?'树脂用炭黑':'Polyresins'" name="fourth">
              <div><SHUZHI></SHUZHI></div>
            </el-tab-pane>
            <el-tab-pane :label="this.$root.language == 1?'涂料油墨等用炭黑':'CoatingAndInk'" name="fifth">
              <div><YOUMO></YOUMO></div>
            </el-tab-pane>
            <el-tab-pane :label="this.$root.language == 1?'其他用途炭黑':'OtherFields'" name="sixth">
              <div ><QITA></QITA></div>
<!--            <div style="height: 500px; margin-top: 50px;text-align: center;font-size: 24px;">产品开发中，敬请期待...</div>-->
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="col-md-2 col-sm-1 col-xs-0 col-lg-2"></div>
      </div>
    </div>
  </div>
</template>

<script>
import LunTai from "../components/product/luntai.vue";
import XIANGJIAO from "../components/product/xiangjiao.vue";
import NENGYUAN from "../components/product/nengyuan.vue";
import SHUZHI from "../components/product/shuzhi.vue";
import YOUMO from "../components/product/youmo.vue";
import QITA from "../components/product/qita.vue";
export default {
  name: "news",
  components: {
    LunTai,
    XIANGJIAO,
    NENGYUAN,
    SHUZHI,
    YOUMO,
    QITA
  },
  data() {
    return {
      loading: true,
      newsList: [],
      newstype: 1,
      title: "产品中心",
      title_en: "Product Center",
      activeName: "first",
      firstList: [
        {
          Id: 1,
          Title: "一系炭黑",
          Type: 1,
          Img: require("../assets/img/N123.jpg"),
          children: [
            {
              Id: 11,
              Content:
                "超高耐磨，正常结构的炭黑，混炼胶具有很强的耐磨性能，主要用于全钢子午胎胎面",
              CreateTime: "2021-08-24 15:48",
              Title: "N110",
              Type: 1,
            },
            {
              Id: 12,
              Content:
                "超高耐磨，正常结构的炭黑，粒径较小，加工件能稍差。混炼胶具有很强的耐磨性能，主要用于全钢子午胎胎面",
              CreateTime: "2021-08-24 15:48",
              Title: "N115",
              Type: 1,
            },
            {
              Id: 13,
              Content:
                "超高耐磨，高结构的炭黑，粒径较大，具有良好的加工性能，混炼胶具有很强的耐磨性能，但比N134稍差，主要用于全钢子午胎胎面",
              CreateTime: "2021-08-24 15:48",
              Title: "N121",
              Type: 1,
            },
            {
              Id: 14,
              Content:
                "超高耐磨，高结构的炭黑，混炼胶具有很强的耐磨性能，主要用于全钢子午胎胎面",
              CreateTime: "2021-08-24 15:48",
              Title: "N134",
              Type: 1,
            },
          ],
        },
        {
          Id: 2,
          Title: "二系炭黑",
          Type: 1,
          Img: require("../assets/img/N220.jpg"),
          children: [
            {
              Id: 21,
              Content:
                "超耐磨，低结构炭黑，混炼胶具有良好的耐切割性能，主要用于工程轮胎，如雨林胎等",
              CreateTime: "2021-08-24 15:48",
              Title: "N219",
              Type: 1,
            },
            {
              Id: 22,
              Content: "超耐磨，正常结构炭黑，主要用于轮胎胎面，输送带等",
              CreateTime: "2021-08-24 15:48",
              Title: "N220",
              Type: 1,
            },
            {
              Id: 23,
              Content:
                "超耐磨，高结构炭黑，混炼胶具有良好的耐磨性能，主要用于全钢、半钢子午胎胎面",
              CreateTime: "2021-08-24 15:48",
              Title: "N234",
              Type: 1,
            },
          ],
        },
        {
          Id: 3,
          Title: "三系炭黑",
          Type: 1,
          Img: require("../assets/img/N375.jpg"),
          children: [
            {
              Id: 31,
              Content:
                "高耐磨，低结构炭黑，混炼胶生热低，硬度低，主要用于子午胎钢丝结合层",
              CreateTime: "2021-08-24 15:48",
              Title: "N326",
              Type: 1,
            },
            {
              Id: 32,
              Content:
                "高耐磨，正常结构炭黑，主要用于斜交胎、子午胎生产，以及橡胶制品的生产，用途广泛",
              CreateTime: "2021-08-24 15:48",
              Title: "N330",
              Type: 1,
            },
            {
              Id: 33,
              Content:
                "高耐磨，高结构炭黑，混炼胶补强性能、加工性能均衡，主要用于斜交胎、子午胎生产",
              CreateTime: "2021-08-24 15:48",
              Title: "N339",
              Type: 1,
            },
            {
              Id: 33,
              Content: "高耐磨，高结构炭黑，类似N339的特性，主要用于子午胎生产",
              CreateTime: "2021-08-24 15:48",
              Title: "N347",
              Type: 1,
            },
            {
              Id: 34,
              Content:
                "高耐磨、高结构炭黑，较大的粒径，主要用于半钢子午胎，轮胎内胎生产",
              CreateTime: "2021-08-24 15:48",
              Title: "N351",
              Type: 1,
            },
            {
              Id: 35,
              Content:
                "高耐磨，高结构炭黑，类似N339的特性，补强性能稍好，主要用于子午轮胎的生产",
              CreateTime: "2021-08-24 15:48",
              Title: "N375",
              Type: 1,
            },
          ],
        },
        {
          Id: 4,
          Title: "五系炭黑",
          Type: 1,
          Img: require("../assets/img/N539.jpg"),
          children: [
            {
              Id: 41,
              Content: "软质炭黑，主要用于轮胎、内胎、胶管、橡胶制品生产",
              CreateTime: "2021-08-24 15:48",
              Title: "N539",
              Type: 1,
            },
            {
              Id: 42,
              Content:
                "软质、高结构炭黑。主要要用于子午轮胎、内胎、胶管、橡胶制品",
              CreateTime: "2021-08-24 15:48",
              Title: "N550",
              Type: 1,
            },
          ],
        },
        {
          Id: 5,
          Title: "六系炭黑",
          Type: 1,
          Img: require("../assets/img/N330.jpg"),
          children: [
            {
              Id: 51,
              Content:
                "软质正常结构炭黑。主要用于斜交胎、子午轮胎、内胎、胶管、橡胶制品生产",
              CreateTime: "2021-08-24 15:48",
              Title: "N660",
              Type: 1,
            },
          ],
        },
        {
          Id: 6,
          Title: "七系炭黑",
          Img: require("../assets/img/N330.jpg"),
          Type: 1,
          children: [
            {
              Id: 61,
              Content: "软质极低结构炭黑，粒径大，结构低，主要用于橡胶制品生产",
              CreateTime: "2021-08-24 15:48",
              Title: "N762",
              Type: 1,
            },
            {
              Id: 22,
              Content:
                "软质低结构炭黑，粒径大，主要用于轮胎气密层、内胎、胶管、橡胶制品生产",
              CreateTime: "2021-08-24 15:48",
              Title: "N774",
              Type: 1,
            },
          ],
        },
      ],
      secondList: [
        {
          Id: 10,
          Title: "轮胎胎面用炭黑",
          Type: 2,
          Img: require("../assets/img/tt.jpg"),
          children: [
            {
              Id: 11,
              Content: "",
              CreateTime: "2021-08-24 15:48",
              Title: "AL12X1",
              Type: 2,
            },
            {
              Id: 12,
              Content: "",
              CreateTime: "2021-08-24 15:48",
              Title: "N134S",
              Type: 2,
            },
          ],
        },
        {
          Id: 12,
          Title: "工业橡胶制品用炭黑",
          Img: require("../assets/img/AL802.jpg"),
          Type: 2,
          children: [
            {
              Id: 13,
              Content: "",
              CreateTime: "2021-08-24 15:48",
              Title: "AL801",
              Type: 2,
            },
            {
              Id: 14,
              Content: "",
              CreateTime: "2021-08-24 15:48",
              Title: "AL802",
              Type: 2,
            },
            {
              Id: 15,
              Content: "",
              CreateTime: "2021-08-24 15:48",
              Title: "AL804",
              Type: 2,
            },
            {
              Id: 16,
              Content: "",
              CreateTime: "2021-08-24 15:48",
              Title: "AL8000",
              Type: 2,
            },
          ],
        },
        {
          Id: 10,
          Title: "中色素炭黑",
          Img: require("../assets/img/AL271.jpg"),
          Type: 2,
          children: [
            {
              Id: 17,
              Content: "",
              CreateTime: "2021-08-24 15:48",
              Title: "AL271",
              Type: 2,
            },
            {
              Id: 18,
              Content: "",
              CreateTime: "2021-08-24 15:48",
              Title: "AL272",
              Type: 2,
            },
            {
              Id: 19,
              Content: "",
              CreateTime: "2021-08-24 15:48",
              Title: "AL273",
              Type: 2,
            },
          ],
        },
        {
          Id: 10,
          Title: "高色素炭黑",
          Type: 2,
          Img: require("../assets/img/tt.jpg"),
          children: [
            {
              Id: 20,
              Content: "",
              CreateTime: "2021-08-24 15:48",
              Title: "AL281",
              Type: 2,
            },
            {
              Id: 21,
              Content: "",
              CreateTime: "2021-08-24 15:48",
              Title: "AL291",
              Type: 2,
            },
          ],
        },
        //{
        //   Id: 10,
        //   Title: "环保系统炭黑",
        //   Type: 2,
        //   children: [
        //     {
        //       Id: 20,
        //       Content: "",
        //       CreateTime: "2021-08-24 15:48",
        //       Title: "敬请期待",
        //       Type: 2,
        //     },
        //   ],
        // }
      ],
      dataList: [
        {
          Id: 11,
          Content:
            "超高耐磨，正常结构的炭黑，混炼胶具有很强的耐磨性能，主要用于全钢子午胎胎面",
          CreateTime: "2021-08-24 15:48",
          Title: "N110",
          Type: 1,
        },
        {
          Id: 12,
          Content:
            "超高耐磨，正常结构的炭黑，粒径较小，加工件能稍差。混炼胶具有很强的耐磨性能，主要用于全钢子午胎胎面",
          CreateTime: "2021-08-24 15:48",
          Title: "N115",
          Type: 1,
        },
        {
          Id: 13,
          Content:
            "超高耐磨，高结构的炭黑，粒径较大，具有良好的加工性能，混炼胶具有很强的耐磨性能，但比N134稍差，主要用于全钢子午胎胎面",
          CreateTime: "2021-08-24 15:48",
          Title: "N121",
          Type: 1,
        },
        {
          Id: 14,
          Content:
            "超高耐磨，高结构的炭黑，混炼胶具有很强的耐磨性能，主要用于全钢子午胎胎面",
          CreateTime: "2021-08-24 15:48",
          Title: "N134",
          Type: 1,
        },
        {
          Id: 21,
          Content:
            "超耐磨，低结构炭黑，混炼胶具有良好的耐切割性能，主要用于工程轮胎，如雨林胎等",
          CreateTime: "2021-08-24 15:48",
          Title: "N219",
          Type: 1,
        },
        {
          Id: 22,
          Content: "超耐磨，正常结构炭黑，主要用于轮胎胎面，输送带等",
          CreateTime: "2021-08-24 15:48",
          Title: "N220",
          Type: 1,
        },
        {
          Id: 23,
          Content:
            "超耐磨，高结构炭黑，混炼胶具有良好的耐磨性能，主要用于全钢、半钢子午胎胎面",
          CreateTime: "2021-08-24 15:48",
          Title: "N234",
          Type: 1,
        },
        {
          Id: 31,
          Content:
            "高耐磨，低结构炭黑，混炼胶生热低，硬度低，主要用于子午胎钢丝结合层",
          CreateTime: "2021-08-24 15:48",
          Title: "N326",
          Type: 1,
        },
        {
          Id: 32,
          Content:
            "高耐磨，正常结构炭黑，主要用于斜交胎、子午胎生产，以及橡胶制品的生产，用途广泛",
          CreateTime: "2021-08-24 15:48",
          Title: "N330",
          Type: 1,
        },
        {
          Id: 33,
          Content:
            "高耐磨，高结构炭黑，混炼胶补强性能、加工性能均衡，主要用于斜交胎、子午胎生产",
          CreateTime: "2021-08-24 15:48",
          Title: "N339",
          Type: 1,
        },
        {
          Id: 33,
          Content: "高耐磨，高结构炭黑，类似N339的特性，主要用于子午胎生产",
          CreateTime: "2021-08-24 15:48",
          Title: "N347",
          Type: 1,
        },
        {
          Id: 34,
          Content:
            "高耐磨、高结构炭黑，较大的粒径，主要用于半钢子午胎，轮胎内胎生产",
          CreateTime: "2021-08-24 15:48",
          Title: "N351",
          Type: 1,
        },
        {
          Id: 35,
          Content:
            "高耐磨，高结构炭黑，类似N339的特性，补强性能稍好，主要用于子午轮胎的生产",
          CreateTime: "2021-08-24 15:48",
          Title: "N375",
          Type: 1,
        },
        {
          Id: 41,
          Content: "软质炭黑，主要用于轮胎、内胎、胶管、橡胶制品生产",
          CreateTime: "2021-08-24 15:48",
          Title: "N539",
          Type: 1,
        },
        {
          Id: 42,
          Content: "软质、高结构炭黑。主要要用于子午轮胎、内胎、胶管、橡胶制品",
          CreateTime: "2021-08-24 15:48",
          Title: "N550",
          Type: 1,
        },
        {
          Id: 61,
          Content: "软质极低结构炭黑，粒径大，结构低，主要用于橡胶制品生产",
          CreateTime: "2021-08-24 15:48",
          Title: "N762",
          Type: 1,
        },
        {
          Id: 22,
          Content:
            "软质低结构炭黑，粒径大，主要用于轮胎气密层、内胎、胶管、橡胶制品生产",
          CreateTime: "2021-08-24 15:48",
          Title: "N774",
          Type: 1,
        },
        {
          Id: 11,
          Content: "轮胎胎面用炭黑",
          CreateTime: "2021-08-24 15:48",
          Title: "AL12X1",
          Type: 2,
        },
        {
          Id: 12,
          Content: "轮胎胎面用炭黑",
          CreateTime: "2021-08-24 15:48",
          Title: "N134S",
          Type: 2,
        },
        {
          Id: 13,
          Content: "工业橡胶制品用炭黑",
          CreateTime: "2021-08-24 15:48",
          Title: "AL801",
          Type: 2,
        },
        {
          Id: 14,
          Content: "工业橡胶制品用炭黑",
          CreateTime: "2021-08-24 15:48",
          Title: "AL802",
          Type: 2,
        },
        {
          Id: 15,
          Content: "工业橡胶制品用炭黑",
          CreateTime: "2021-08-24 15:48",
          Title: "AL804",
          Type: 2,
        },
        {
          Id: 16,
          Content: "工业橡胶制品用炭黑",
          CreateTime: "2021-08-24 15:48",
          Title: "AL8000",
          Type: 2,
        },
        {
          Id: 17,
          Content: "中色素炭黑",
          CreateTime: "2021-08-24 15:48",
          Title: "AL271",
          Type: 2,
        },
        {
          Id: 18,
          Content: "中色素炭黑",
          CreateTime: "2021-08-24 15:48",
          Title: "AL272",
          Type: 2,
        },
        {
          Id: 19,
          Content: "中色素炭黑",
          CreateTime: "2021-08-24 15:48",
          Title: "AL273",
          Type: 2,
        },
        {
          Id: 20,
          Content: "高色素炭黑",
          CreateTime: "2021-08-24 15:48",
          Title: "AL281",
          Type: 2,
        },
        {
          Id: 21,
          Content: "高色素炭黑",
          CreateTime: "2021-08-24 15:48",
          Title: "AL291",
          Type: 2,
        },
        {
          Id: 211,
          Content: "环保系统炭黑,敬请期待！",
          CreateTime: "2021-08-24 15:48",
          Title: "",
          Type: 2,
        },
      ],
      showContent: false,
    };
  },
  methods: {
    loadData() {
      this.loading = true;
      if (this.newstype == 1) {
        this.newsList = this.firstList;
        this.showContent = false;
      } else {
        this.newsList = this.secondList;
        window.console.log(this.newsList);
        this.showContent = true;
      }
    },
    handleClick(row) {
      console.log(row);
    },
    tabClick(tab, event) {
      console.log(tab, event);
    },
    clickPhone(row) {
      console.log(row);
    },
  },
  mounted() {
    this.loadData();
    // this.postData()
  },
  watch: {
    newstype(type) {
      window.console.log(type);
      this.loadData();
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.news {
  width: 100%;
  height: 100%;
  background-color: #eeeeee;
  position: relative;
  overflow: hidden;

  &-section {
    width: 100%;
    margin-bottom: 145px;
    //height: 1600px;

    &-content {
      // width: 1240px;
      // margin: 0 auto;
      background-color: #eeeeee;
      // border: 1px solid red;
      border: none;

      .content-nav {
        width: 400px;
        height: 55px;
        margin: 0 auto;
        display: flex;
        //justify-content: center;
        align-items: center;
        position: relative;
        bottom: 30px;
        border: 1px solid red;
        cursor: pointer;

        &-btn {
          width: 50%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #e4e4e4;
          transition: all 0.2s;
        }

        .content-nav-active {
          background-color: red;
          color: #fff;
        }
      }

      .content-nav-item {
        width: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        //border: 1px solid blue;
        .text-content {
          text-indent: 2em;
          font-size: 18px;
        }

        .item-list {
          // width: 330px;
          height: auto;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin: 10px auto;
          // border: 1px solid #15669e;
          background-color: rgb(250, 250, 250);
          // &:hover {
          //   border: 1px solid #fff;
          //   box-shadow: 0 0 5px 2px #bfd3e0;
          // }
          .item-img {
            width: 300px;
            height: 210px;
            background-color: #cecece;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            background-origin: content-box;
          }

          &-title {
            width: 300px;
            height: 60px;
            color: #15669e;
            font-size: 22px;
            padding: 0 10px;
            margin: 20px 0 20px 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            border-left: 1px solid #15669e;
          }

          &-content {
            width: 100%;
            height: 100px;
            font-size: 14px;
            color: gray;
            text-indent: 2em;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            // 文本长度处理 ending
          }

          &-more {
            width: 273px;
            padding-top: 20px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            img {
              width: 12px;
              height: 12px;
            }
            span {
              color: #e13834;
              padding: 0 5px;
            }
          }

          .cst_cardlist_grid_icon {
            background-color: rgba(0, 0, 0, 0);
            margin-bottom: 0px;
            .cst_textSetting {
              padding-bottom: 0px;
              border-bottom: 1px solid rgb(79, 79, 79);
              align-items: flex-start;
              flex-flow: row wrap;
              color: #434343;
              text-align: left;
              &::before {
                display: table;
                content: "";
              }
              .c-inline-column {
                float: none;
                display: inline-block;
                vertical-align: top;
                word-spacing: normal;
                min-height: 80px;
                background-color: transparent;
                padding: 0;
                text-align: center;
                .cst_block_item {
                  transform: rotate(0deg) scale(1) translate(0%, 0%);
                  transition: all 0.3s ease;
                  &:hover {
                    box-shadow: rgb(0, 0, 0) 0px 4px 10px 0px;
                    transform: rotate(0deg) scale(1) translate(0%, -5%);
                    transition: all 0.3s ease;
                    z-index: 10;
                  }
                }
              }
            }
          }
        }
      }
    }
    .row {
      width: 100%;
      .tableWrap {
        .el-table th.el-table__cell {
          background-color: #ee7a18 !important;
        }
      }
    }
    // .loop(@n) when (@n <100) {
    //   .el-table__body {
    //     .el-table__row:nth-child(@{n}) {
    //       opacity: 0;
    //       animation: table-show 500ms @n * 50ms forwards ease-out;
    //     }
    //   }
    //   .loop((@n + 1))
    // }
    // .loop(0);
    @for $i from 1 through 1000 {
      .el-table__body {
        .el-table__row:nth-child(#{$i}) {
          opacity: 0;
          animation: table-show 500ms $i * 50ms forwards ease-out;
        }
      }
    }
    @keyframes table-show {
      0% {
        transform: translateY(50px);
        opacity: 0.5;
      }
      100% {
        transform: translateY(0);
        opacity: 1;
      }
    }
  }
  .text-decoration {
    text-decoration: none;
  }
  .banner {
    width: 100%;
    height: 300px;
    display: flex;
    position: relative;
    overflow: hidden;
    img {
      position: absolute;
      height: 100%;
      width: 100%;
    }
    &-title {
      position: absolute;
      color: #ffffff;
      font-size: 45px;
      font-weight: 400;
      line-height: 300px;
      text-align: center;
      width: 100%;
    }
  }
}
// ::selection{
//   background: #ee7a18;
// }
.tableWrap{
  padding-top: 100px;
}
::v-deep.el-table tbody tr:hover > td {
  border-bottom: 1px solid #ee7a18;
  width: 100%;
  transition: 0.2s all linear;
  transition-delay: 0.1s;
}
.table-tab {
  .el-tabs__item {
    width: 200px;
    height: 80px;
  }
}
::v-deep .el-tabs__nav-scroll{
  background-color: #ee7a18;
}
::v-deep .el-tabs__nav{
  background-color: #ee7a18;
  color: #ffffff;
}
::v-deep .el-tabs__item.is-active {
  color: #ffffff;
}
::v-deep .el-tabs__active-bar {
  background-color: #ee7a18;
}
::v-deep .el-tabs__item:hover {
    color: #ffffff;
    cursor: pointer;
}
::v-deep .el-tabs__nav-wrap::after{
  background-color: #ee7a18;
}
::v-deep #tab-first {
  width: 200px;
  text-align: center;
  height: 80px;
  line-height: 80px;
  font-size: 18px;
  padding-left: 20px !important;
}
::v-deep #tab-second {
  width: 200px;
  text-align: center;
  height: 80px;
  line-height: 80px;
  font-size: 18px;
  padding-left: 20px !important;
}
::v-deep #tab-third {
  width: 200px;
  text-align: center;
  height: 80px;
  line-height: 80px;
  font-size: 18px;
  padding-left: 20px !important;
}
::v-deep #tab-fourth {
  width: 200px;
  text-align: center;
  height: 80px;
  line-height: 80px;
  font-size: 18px;
  padding-left: 20px !important;
}
::v-deep #tab-fifth {
  width: 200px;
  text-align: center;
  height: 80px;
  line-height: 80px;
  font-size: 18px;
  padding-left: 20px !important;
}
::v-deep #tab-sixth {
  width: 200px;
  text-align: center;
  height: 80px;
  line-height: 80px;
  font-size: 18px;
  padding-left: 20px !important;
}
</style>